<form [formGroup]="searchForm" (ngSubmit)="searchDeals()" id="query-form">
    <mat-form-field appearance="fill" class="search-bar">
        <mat-label>{{ label }}</mat-label>
        <mat-placeholder>{{ label }}</mat-placeholder>
        <input class="form-control" type="text" matInput formControlName="query" autocomplete="off" />
        <button *ngIf="!isFiltered" matSuffix mat-icon-button type="button">
            <mat-icon class="search-icon" role="graphics-symbol" title="Search">search</mat-icon>
        </button>
        <button *ngIf="isFiltered" (click)="clear()" matSuffix mat-icon-button type="button">
            <mat-icon role="graphics-symbol" title="Clear">close</mat-icon>
        </button>
    </mat-form-field>
</form>
